import axios from "axios";
import { baseURL } from "../config/api";

export const calculate = (data: any, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/Calculate`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const confirmBooking = (data: any, status: string, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}rentals/ConfirmBooking`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data,
        params: {
            status,
            userId
        }
    }).then(response => response.data);
}

export const getReservationSummary = (primaryKey: number, tenantId: string) => {
    return getFetch(`rentals/GetReservationSummaryForCustomer`, tenantId, { id: primaryKey });
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
        },
        params: params
    }).then(response => response.data);
}